<template>
  <div :style="{flex: 1, margin: 0}"></div>
</template>

<script>
export default {
  name: "AutoFlex"
};
</script>